import React, { useEffect, useState } from 'react';

const ROLE_OPTIONS = ['SuperAdmin', 'Admin', 'AdminTournament', 'MatchEditor'];

function Users({ socket, user }) {
  const [users, setUsers] = useState([]);
  const [newUser, setNewUser] = useState({ username: '', password: '', role: 'Admin' });
  const [roleEdits, setRoleEdits] = useState({});

  const canManageUsers = user && (user.role === 'SuperAdmin' || user.role === 'Admin');

  useEffect(() => {
    if (!socket || !canManageUsers) return;

    const handleUsers = (rows) => {
      setUsers(Array.isArray(rows) ? rows : []);
      const nextEdits = {};
      (Array.isArray(rows) ? rows : []).forEach((u) => {
        nextEdits[u.id] = u.role;
      });
      setRoleEdits(nextEdits);
    };

    socket.on('users', handleUsers);
    socket.emit('getUsers');

    return () => {
      socket.off('users', handleUsers);
    };
  }, [socket, canManageUsers]);

  const addUser = (e) => {
    e.preventDefault();
    if (!socket || !canManageUsers) return;
    if (!newUser.username.trim() || !newUser.password.trim()) return;

    socket.emit('addAppUser', {
      username: newUser.username.trim(),
      password: newUser.password,
      role: newUser.role,
    });

    setNewUser({ username: '', password: '', role: 'Admin' });
  };

  const saveRole = (id) => {
    if (!socket || !canManageUsers) return;
    const nextRole = roleEdits[id];
    if (!nextRole) return;
    socket.emit('updateAppUserRole', { id, role: nextRole });
  };

  const deleteUser = (target) => {
    if (!socket || !canManageUsers) return;
    if (Number(target.id) === Number(user?.id)) return;
    if (!window.confirm(`Poistetaanko käyttäjä "${target.username}"?`)) return;
    socket.emit('deleteAppUser', target.id);
  };

  if (!canManageUsers) {
    return (
      <div className="users-section">
        <h2>Käyttäjät</h2>
        <p>Sinulla ei ole oikeuksia käyttäjien hallintaan.</p>
      </div>
    );
  }

  return (
    <div className="users-section">
      <h2>Käyttäjät</h2>

      <section className="users-create-block">
        <h3>Luo uusi käyttäjä</h3>
        <form onSubmit={addUser}>
          <input
            type="text"
            placeholder="Käyttäjätunnus"
            value={newUser.username}
            onChange={(e) => setNewUser((prev) => ({ ...prev, username: e.target.value }))}
          />
          <input
            type="password"
            placeholder="Salasana"
            value={newUser.password}
            onChange={(e) => setNewUser((prev) => ({ ...prev, password: e.target.value }))}
          />
          <select
            value={newUser.role}
            onChange={(e) => setNewUser((prev) => ({ ...prev, role: e.target.value }))}
          >
            {ROLE_OPTIONS.map((role) => (
              <option key={role} value={role}>{role}</option>
            ))}
          </select>
          <button type="submit">Lisää käyttäjä</button>
        </form>
      </section>

      <section className="users-list-block">
        <h3>Käyttäjälista</h3>
        <div className="users-table-wrapper">
          <table className="users-table">
            <thead>
              <tr>
                <th>Käyttäjätunnus</th>
                <th>Rooli</th>
                <th>Toiminnot</th>
              </tr>
            </thead>
            <tbody>
              {users.map((row) => (
                <tr key={row.id}>
                  <td>{row.username}</td>
                  <td>
                    <select
                      value={roleEdits[row.id] || row.role}
                      onChange={(e) => setRoleEdits((prev) => ({ ...prev, [row.id]: e.target.value }))}
                    >
                      {ROLE_OPTIONS.map((role) => (
                        <option key={role} value={role}>{role}</option>
                      ))}
                    </select>
                  </td>
                  <td className="users-actions">
                    <button type="button" onClick={() => saveRole(row.id)}>
                      Tallenna
                    </button>
                    <button
                      type="button"
                      className="delete-button"
                      onClick={() => deleteUser(row)}
                      disabled={Number(row.id) === Number(user?.id)}
                    >
                      Poista
                    </button>
                  </td>
                </tr>
              ))}
              {users.length === 0 && (
                <tr>
                  <td colSpan="3">Käyttäjiä ei löytynyt.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </section>
    </div>
  );
}

export default Users;
